import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, Ref } from 'vue'
import { ISignin, LocalizationPath, SigninFactory, UserType } from '@tokyojob/core'
import {
  ButtonFactory,
  CTextInput,
  ForgotPasswordRoute,
  TextInputFactory,
  InputFieldType,
  CButton,
  getLocalization,
  RouterLinkFactory
} from '@tokyojob/frontend-components'
import { ValidationObserver } from 'vee-validate'
import { LocalizationService } from '../../../../../../../core/src/modules'
import { getProvidedApp, getRouter } from '~/base/utils/provided-getter'
import { IApp } from '~/types/nuxt'

// Props definition

export default /*#__PURE__*/_defineComponent({
  __name: 'c-login-form.component',
  props: {
  userType: {
    type: String,
    required: true
  }
},
  emits: ['submit'],
  setup(__props, { emit }) {

const props = __props;



// Emitter for submit event


// Reactive state for form inputs and buttons
const isCandidate = computed(() => props.userType === UserType.Candidate)

const App: IApp = getProvidedApp()
const localization = getLocalization(App)
const accountIdInput = ref(
  TextInputFactory.SmallTextInputRequired({
    label: LocalizationService.t(localization, LocalizationPath.email),
    placeholder: '',
    validation: { required: true, mobileOrEmail: true },
    showAsterisk: false,
    css: 'btn-lg theme-shades-medium2-white'
  })
)

const passwordInput = ref(
  TextInputFactory.SmallTextInputRequired({
    label: LocalizationService.t(localization, LocalizationPath.password),
    placeholder: '',
    type: InputFieldType.Password,
    showAsterisk: false,
    css: 'btn-lg theme-shades-medium2-white'
  })
)

// Sign in credentials
const signinCredentials = ref({
  account: '',
  password: ''
}) as Ref<ISignin>

const router = getRouter()
// Recovery and login buttons
const recoveryButton = computed(() =>
  isCandidate.value
    ? ButtonFactory.textOnlyLinkBlueUnderline({
        label: LocalizationService.t(localization, LocalizationPath.forgotPassword),
        cyTag: 'candidate-reset-cy'
      })
    : ButtonFactory.textOnlyLinkBlueUnderline({
        label: LocalizationService.t(localization, LocalizationPath.forgotPassword),
        cyTag: 'agent-reset-cy'
      })
)

function redirect() {
  const link = isCandidate.value ? ForgotPasswordRoute.Candidate : ForgotPasswordRoute.Agent
  const localizedLink = RouterLinkFactory.localizedLink(link, App.localizationSelector.language)
  router.push(localizedLink)
}

const loginButton = computed(() => {
  const label = LocalizationService.t<string>(localization, LocalizationPath.login)
  const btn = isCandidate.value ? ButtonFactory.loginCandidate() : ButtonFactory.loginAgent()
  btn.label = label
  return btn
})

// Submit method
const submit = async (validate: Function) => {
  if (!(await validate())) return
  emit('submit', signinCredentials.value)
}

return { __sfc: true,props, emit, isCandidate, App, localization, accountIdInput, passwordInput, signinCredentials, router, recoveryButton, redirect, loginButton, submit, CTextInput, CButton, ValidationObserver }
}

})